import { render, staticRenderFns } from "./VoucherSegmentClientList.vue?vue&type=template&id=626b159e&scoped=true"
import script from "./VoucherSegmentClientList.vue?vue&type=script&lang=js"
export * from "./VoucherSegmentClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b159e",
  null
  
)

export default component.exports